import apiFactory from "../api";

const onDownloadProgress = (
  progressEvent,
  setProgress,
  volume,
  abortController
) => {
  if (abortController?.signal?.aborted) {
    return;
  }
  const total = progressEvent.total || 1; // Fallback to 1 to prevent division by zero
  const current = progressEvent.loaded;
  setProgress(Math.round((current / volume) * 100));
};

export const downloadFileOrPhoto = async (
  event,
  {
    url,
    originalName,
    setProgress,
    volume,
    abortController,
    setIsActionDisabled = () => {},
    isFree = false,
  }
) => {
  event.preventDefault();

  try {
    let response;

    if (!isFree) {
      response = await apiFactory.resourceApi.getFile(
        url,
        (progressEvent) =>
          onDownloadProgress(
            progressEvent,
            setProgress,
            volume,
            abortController
          ),
        abortController?.signal
      );
    } else {
      response = await apiFactory.resourceApi.getFreeFile(
        url,
        (progressEvent) =>
          onDownloadProgress(
            progressEvent,
            setProgress,
            volume,
            abortController
          ),
        abortController?.signal
      );
    }

    const blob = new Blob([response.data], {
      type: response.headers["content-type"],
    });
    const urlDownload = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = urlDownload;
    link.download = originalName;

    document.body.appendChild(link);
    link.click();

    // Clean up and revoke the object URL
    document.body.removeChild(link);
    window.URL.revokeObjectURL(urlDownload);

    setTimeout(() => {
      setProgress(0);
      setIsActionDisabled(false);
    }, 1000);
  } catch (error) {
    abortController.abort();
    setProgress(0);
  }
};

export const handleCancelDownload = (
  abortController,
  setAbortController,
  setDownloadProgress,
  isActionDisabled,
  setIsActionDisabled
) => {
  setIsActionDisabled(true);

  if (abortController) {
    abortController.abort();
    setAbortController(null);
  }

  setTimeout(() => setIsActionDisabled(false), 2000);
};
